import { AxiosResponse } from 'axios';

import { CustomerConfigI, CustomerI, FaqI } from '../../declarations/interfaces/customer';
import { get } from '../api';

export const getCustomerByName = async (customerName: string): Promise<AxiosResponse<CustomerI>> =>
  await get(`/admin/customers/find/${customerName}`);

export const getCustomerConfigById = async (
  customerId: string
): Promise<AxiosResponse<CustomerConfigI>> =>
  await get(`/admin/affiliate/setup?uuid=${customerId}`);

export const getFaqData = async (customerId: string): Promise<AxiosResponse<FaqI[]>> =>
  await get(`/admin/customer-faq/find/customer/${customerId}/localization`);
